import { render, staticRenderFns } from "./getExchange.vue?vue&type=template&id=515d60da&scoped=true"
import script from "./getExchange.vue?vue&type=script&lang=js"
export * from "./getExchange.vue?vue&type=script&lang=js"
import style0 from "./getExchange.vue?vue&type=style&index=0&id=515d60da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d60da",
  null
  
)

export default component.exports